import React, { useContext, useState } from "react";

import { CButton } from "@coreui/react";
import { useSelector } from "react-redux";

import { elementToPDF } from "../../../../utils/export";
import Charts from "../../../Charts";
import LoadingStatistics from "../../../LoadingStatistics";
import StatisticFiltersCompare from "../../../StatisticFiltersCompare";
import "./styles.scss";
import { DataContext } from "../../Context/DataContext";

export default function ComparacaoRegional({
  activity_id: activityId,
  school_id: schoolId,
  ...rest
}) {
  const { dataComparisonRegions, loading, firstLoad, fetchData } =
    useContext(DataContext);
  const token = useSelector(state => state.user.token);
  const [data, setData] = dataComparisonRegions;
  const route = "statistics/evaluation_comparison";

  const getRandomColor = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgba(${r}, ${g}, ${b}`;
  };

  const colorMap =
    data?.regions?.map(() => ({
      colorBase: `${getRandomColor()}`
    })) || [];

  const changeFilter = selected => {
    if (selected.groupId === 0) {
      return;
    }

    const params = {
      group_id: selected.groupId,
      activity_id: activityId,
      ...(schoolId && { school_id: schoolId })
    };

    fetchData(params, token, route, setData);
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="layoutTabelaComparacao flex-column w-100">
        <StatisticFiltersCompare
          activityId={activityId}
          onChange={changeFilter}
          hideUser
          hideRoom
          hideSchool
          hideRegion
        />
      </div>
      <div className="w-100">
        {loading ? (
          <LoadingStatistics />
        ) : data?.regions?.length > 0 && data ? (
          <div className="w-100">
            <div className="d-flex w-100 justify-content-end mt-3 mb-2">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  elementToPDF("toPrint", "Comparação entre Regionais.pdf")
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
              </CButton>
            </div>
            <div className="w-100" id="toPrint">
              <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
                <div className="row">
                  <div className="chart w-100">
                    {schoolId ? (
                      <Charts
                        legendY="Regionais"
                        legendX="Nota Média"
                        type="horizontalbar"
                        title="Comparação entre Regionais"
                        data={{
                          labels: [
                            data.school.name, // Adiciona o nome da escola como o primeiro item
                            ...data.regions.map(region => region.name)
                          ],
                          datasets: [
                            {
                              data: [
                                data.school.grade, // Adiciona a nota da escola como o primeiro item
                                ...data.regions.map(region => region.grade),
                                data.max
                              ],
                              backgroundColor: [
                                "rgba(255, 99, 132, 0.5)", // Cor específica para a escola
                                ...colorMap.map(
                                  color => `${color.colorBase}, 0.2)`
                                )
                              ],
                              borderColor: [
                                "rgba(255, 99, 132, 1)", // Cor específica para a escola
                                ...colorMap.map(
                                  color => `${color.colorBase}, 1)`
                                )
                              ],
                              borderWidth: 1
                            }
                          ]
                        }}
                      />
                    ) : (
                      <Charts
                        legendY="Regionais"
                        legendX="Nota Média"
                        type="horizontalbar"
                        title="Comparação entre Regionais"
                        data={{
                          labels: [...data.regions.map(region => region.name)],
                          datasets: [
                            {
                              data: [
                                ...data.regions.map(region => region.grade),
                                data.max
                              ],
                              backgroundColor: [
                                ...colorMap.map(
                                  color => `${color.colorBase}, 0.2)`
                                )
                              ],
                              borderColor: [
                                ...colorMap.map(
                                  color => `${color.colorBase}, 1)`
                                )
                              ],
                              borderWidth: 1
                            }
                          ]
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : firstLoad ? (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Selecione os filtros para pesquisar
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Nenhuma aplicação da avaliação foi encontrada
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
